module.exports = __webpack_public_path__ + "img/lr.309ccbd8.svg";